import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { clusterApiUrl } from '@solana/web3.js';
import { useMemo } from 'react';
import { ProgramProvider } from './contexts/ProgramContext';
import StakingInterface from './components/StakingInterface';
import { CONFIG } from './config';

// Import wallet adapter CSS
import '@solana/wallet-adapter-react-ui/styles.css';

function App() {
  const networkMap: Record<string, WalletAdapterNetwork> = {
    'devnet': WalletAdapterNetwork.Devnet,
    'testnet': WalletAdapterNetwork.Testnet,
    'mainnet-beta': WalletAdapterNetwork.Mainnet,
    'localnet': WalletAdapterNetwork.Devnet,
  };

  const network = networkMap[CONFIG.NETWORK] || WalletAdapterNetwork.Devnet;

  const endpoint = useMemo(() => {
    if (CONFIG.NETWORK === 'localnet' || import.meta.env.VITE_RPC_URL) {
      return CONFIG.RPC_URL;
    }
    return clusterApiUrl(network);
  }, [network]);

  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter({ network }),
    ],
    [network]
  );

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <ProgramProvider>
            <div className="min-h-screen bg-habitat-neutral-50">
              <header className="bg-white border-b border-habitat-neutral-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                  <div className="flex justify-between items-center py-4">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-habitat-primary to-habitat-accent rounded-lg flex items-center justify-center">
                        <span className="text-white font-bold text-xl">H</span>
                      </div>
                      <h1 className="text-2xl font-bold text-habitat-neutral-900">
                        Habitat Staking
                      </h1>
                    </div>
                    <WalletMultiButton />
                  </div>
                </div>
              </header>
              <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <StakingInterface />
              </main>
              <footer className="bg-white border-t border-habitat-neutral-200 mt-12">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                  <p className="text-center text-sm text-habitat-neutral-500">
                    © 2025 Habitat Protocol. All rights reserved.
                  </p>
                </div>
              </footer>
            </div>
          </ProgramProvider>
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  );
}

export default App;